module.exports = __webpack_public_path__ + "img/ipad_cn.9c46306.jpg";